import styled from "styled-components";

import {
  FontSize,
  P,
} from '../../../../styles'

export const ContactInfo = styled(P).attrs(props => ({
  className: `ContactInfo` 
}))`
  font-size: ${FontSize.address};
`
